import { useAuth } from '../auth'
import { useSidebar } from '../context/SidebarContext'
import { useIsMobile } from '../hooks/useIsMobile'

const C = { teal: '#2B4C5E', yellow: '#F2B705', orange: '#F5A800' }

export default function Navbar() {
  const { account, logout } = useAuth()
  const { toggle } = useSidebar()
  const isMobile = useIsMobile()

  return (
    <nav style={{
      background:  C.teal,
      color:       '#fff',
      display:     'flex',
      alignItems:  'center',
      padding:     '0 16px',
      height:      64,
      position:    'fixed',
      top: 0, left: 0, right: 0,
      zIndex:      1000,
      boxShadow:   '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      {isMobile && (
        <button onClick={toggle} style={{
          background: 'none', border: 'none', color: '#fff',
          fontSize: 22, cursor: 'pointer', marginRight: 12, padding: '4px 6px',
          lineHeight: 1,
        }}>☰</button>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
        <img src="/logo.jpg" alt="BNF" style={{
          width: 40, height: 40, borderRadius: 6,
          objectFit: 'contain', background: '#fff', flexShrink: 0,
        }} />
        {!isMobile && (
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: 0.5 }}>BNF Report Platform</div>
            <div style={{ fontSize: 10, color: C.yellow, letterSpacing: 1 }}>BUSINESS NEXTGEN FINANCE</div>
          </div>
        )}
      </div>

      {account && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {!isMobile && (
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{account.name}</div>
              <div style={{ fontSize: 11, color: '#C7D9DB' }}>{account.username}</div>
            </div>
          )}
          <div style={{
            width: 34, height: 34, borderRadius: '50%',
            background: C.yellow, color: C.teal,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: 14, flexShrink: 0,
          }}>
            {account.name?.charAt(0).toUpperCase()}
          </div>
          <button onClick={logout} style={{
            background: 'transparent', border: '1px solid #6B8A91',
            color: '#C7D9DB', padding: '4px 10px', borderRadius: 4,
            cursor: 'pointer', fontSize: 12, whiteSpace: 'nowrap',
          }}>
            Sign out
          </button>
        </div>
      )}
    </nav>
  )
}
